import React,{useState} from 'react';
import EmployAside from '../aside';
import NouveauEmail from './nouveau-email';

const NouveauBoitesMail = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className='main-page-wrapper'>
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar}/>

      <NouveauEmail setIsOpenSidebar={setIsOpenSidebar}/>
    </div>    
  );
};

export default NouveauBoitesMail;